import { MAX_PLAYER_NAME_LENGTH } from "../../constants";
import { getLevel } from "./exp";

/**
 * Clip a player name.
 * @param {string} name
 * @returns {string}
 */
export function clipPlayerName(name) {
  if (!name) {
    return "";
  }
  return name.length > MAX_PLAYER_NAME_LENGTH
    ? `${name.substring(0, MAX_PLAYER_NAME_LENGTH)}...`
    : name;
}

/**
 * Get the color associated with a player's name based on their points.
 * @param {number} points - The points of the player.
 * @returns {string} The color associated with the player's name.
 */
export function getPlayerNameColor(points) {
  const level = getLevel(points);
  let color = "#2ecc71";
  if (level >= 60) {
    color = "#e67e22";
  } else if (level >= 40) {
    color = "#9b59b6";
  } else if (level >= 20) {
    color = "#3498db";
  }
  return color;
}
